<template>
  <div class="custom-form">
    <div class="panel panel-primary">
      <div class="panel-heading">
        <h3 class="panel-title">SECURE FILE UPLOAD</h3>
      </div>
      <div class="panel-body">
        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('upl_PersonName') }"
        >
          <label for="upl_PersonName">Your name</label>
          <input
            id="upl_PersonName"
            name="upl_PersonName"
            v-model.trim="fdata.upl_PersonName"
            v-validate.initial="{ required: true, max: 100 }"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("upl_PersonName") }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('upl_Email') }"
        >
          <label for="upl_Email">E-mail</label>
          <input
            id="upl_Email"
            name="upl_Email"
            v-model.trim="fdata.upl_Email"
            v-validate.initial="{ required: true, max: 100, email: true }"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("upl_Email") }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('upl_File') }"
        >
          <label for="upl_File">Select file</label>
          <input
            ref="upl_File"
            name="upl_File"
            @change="onFileChange_upl_File"
            v-validate.initial="{
              required: true,
              mimes: [
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/pdf',
                'image/*',
              ],
              size: 5000,
            }"
            class="form-control"
            type="file"
          />
          <span class="help-block">{{ errors.first("upl_File") }}</span>
        </div>

        <div class="vue-recaptcha-wrapper">
          <vue-recaptcha
            ref="upl_recaptcha"
            id="upl_recaptcha"
            v-on:verify="verifyRecaptcha"
            sitekey="6LdX-LIZAAAAABpe4OAYaWst24JQdg_qtQ9rleGo"
          ></vue-recaptcha>
        </div>

        <modal
          name="alert-dialog2"
          :width="400"
          :height="'auto'"
          :clickToClose="false"
        >
          <div class="panel-primary">
            <div class="panel-heading modal-alert-heading">
              <span class="modal-alert-title">Information</span>
              <button
                @click="closeAlertDialog"
                type="button"
                class="close pull-right"
              >
                <span
                  class="fa fa-times-circle modal-alert-close-button-icon"
                ></span>
              </button>
            </div>
            <div class="panel-body modal-alert-body">
              <div class="modal-alert-text-wrapper">
                <span class="fa fa-exclamation-circle modal-alert-icon"></span>
                <span class="modal-alert-text">{{ alertMessage }}</span>
              </div>
              <div class="modal-alert-footer">
                <button
                  @click="closeAlertDialog"
                  type="button"
                  class="btn btn-success"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </modal>

        <div class="btn-submit-wrapper">
          <div v-if="showAnimation" class="cc-animation">
            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            <br />
            <span>Form submission in progress</span>
          </div>
          <div class="cc-submit-btn-wrapper">
            <button
              v-on:click="saveFormData"
              v-bind:disabled="disableStatus_upl_recaptcha || showAnimation"
              type="submit"
              class="btn btn-primary"
              style="width: 120px;"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
import axios from "axios";

export default {
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      fdata: {
        upl_PersonName: "",
        upl_Email: "",
        upl_File: "",
        upl_RecaptchaResponse: "",
      },
      showAnimation: false,
      alertMessage: "",
      formData: new FormData(),
    };
  },
  methods: {
    saveFormData: async function() {
      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog2");
        return;
      }

      this.formData.delete("json");
      this.formData.append("json", JSON.stringify(this.fdata));

      this.showAnimation = true;
      let rData = null;
      const actionUrl = "/Upload/SaveToGoogleDrive";
      try {
        ({ data: rData } = await axios.post(actionUrl, this.formData));        
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }

      if (rData != 0) {
        this.showAnimation = false;
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog2");
        return;
      }

      this.resetFormData();
      this.alertMessage = "File submitted successfully";
      this.$modal.show("alert-dialog2");
      this.showAnimation = false;
    },
    resetFormData: function() {
      Object.assign(this.fdata, {
        // upl_PersonName: "",
        // upl_Email: "",
        upl_RecaptchaResponse: "",
      });
      this.$refs.upl_recaptcha.reset();
      this.$refs.upl_File.value = null;
      this.formData = new FormData();
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog2");
    },
    onFileChange_upl_File: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.formData.delete("upl_File");
      this.formData.append("upl_File", files[0]);
    },
    verifyRecaptcha: function(value) {
      if (value) {
        this.fdata.upl_RecaptchaResponse = value;
      }
    },
  },
  computed: {
    disableStatus_upl_recaptcha: function() {
      if (this.fdata.upl_RecaptchaResponse) {
        return false;
      }
      return true;
    },
  },
};
</script>
